import {
  makeStyles,
  tokens,
  type GriffelStyle,
} from "@fluentui/react-components";
import type { Appearance } from "../data";

type Styles = {
  tab: GriffelStyle;
  selected: GriffelStyle;
  text: GriffelStyle;
  selectedText: GriffelStyle;
};

const defaultStyles: Styles = {
  tab: {},
  selected: {},
  text: {},
  selectedText: { fontWeight: "600" },
};

const inAppV2Styles: Styles = {
  tab: {
    height: "32px",
    backgroundColor: tokens.colorBrandBackground2,
  },
  selected: {
    height: "32px",
    backgroundColor: tokens.colorBrandBackground,
  },
  text: {
    fontWeight: "600",
  },
  selectedText: {
    fontWeight: "600",
  },
};

const webV2Styles: Styles = {
  tab: {
    height: "40px",
    backgroundColor: tokens.colorBrandBackground2,
  },
  selected: {
    height: "40px",
    backgroundColor: tokens.colorBrandBackground,
  },
  text: {
    fontWeight: "600",
  },
  selectedText: {
    fontWeight: "600",
  },
};

const useDefaultStyles = makeStyles(defaultStyles);
const useWebV2Styles = makeStyles(webV2Styles);
const useInAppV2Styles = makeStyles(inAppV2Styles);

export const useStyles = (appearance?: Appearance) => {
  switch (appearance) {
    case "web-v2":
      return useWebV2Styles;
    case "in-app-v2":
      return useInAppV2Styles;
    default:
      return useDefaultStyles;
  }
};
